import { gql } from '@apollo/client';

export const STARTER_INTERVIEW_QUESTION_TEMPLATE = gql`
  query StarterInterviewQuestionTemplate {
    starterInterviewQuestionTemplate {
      id
      question
      difficulty
      sortOrder
      position
    }
  }
`

export const ADD_STARTER_TEMPLATE_QUESTION = gql`
  mutation AddStarterTemplateQuestion($question: String!, $difficulty: Int, $position: InterviewQuestionPosition) {
    addStarterTemplateQuestion(question: $question, difficulty: $difficulty, position: $position) {
      id
      question
      difficulty
      sortOrder
      position
    }
  }
`

export const UPDATE_STARTER_TEMPLATE_QUESTION = gql`
  mutation UpdateStarterTemplateQuestion($id: String!, $question: String, $difficulty: Int, $position: InterviewQuestionPosition) {
    updateStarterTemplateQuestion(id: $id, question: $question, difficulty: $difficulty, position: $position) {
      id
      question
      difficulty
      sortOrder
      position
    }
  }
`

export const DELETE_STARTER_TEMPLATE_QUESTION = gql`
  mutation DeleteStarterTemplateQuestion($id: String!) {
    deleteStarterTemplateQuestion(id: $id)
  }
`

export const REORDER_STARTER_TEMPLATE_QUESTIONS = gql`
  mutation ReorderStarterTemplateQuestions($orderedIds: [String!]!) {
    reorderStarterTemplateQuestions(orderedIds: $orderedIds) {
      id
      question
      difficulty
      sortOrder
      position
    }
  }
`
